// removed by extract-text-webpack-plugin
module.exports = {"box":"_1xaJXkRxdBwBVydPkKukIM","needApprove":"_1CU9UgCKxWYF1s4ESYpZzH"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/organisms/Timeline/Containers/style.css
// module id = 67
// module chunks = 38